// import { useEffect, useRef, useState } from "react";
// import Svg from "./figs/Svg";
// import { useSelector } from "react-redux";

// export default function MultiSelect({
//   className = "",
//   placeholder = "",
//   disabled = false,
//   onSelectOption = () => {},
//   onSaveNewOption = () => {},
//   selectedOption = [],
//   multiple = true,
//   disabledAddNewOption = false,
//   options = [
//     { value: 1, label: "LABEL OPTION 1" },
//     { value: 2, label: "LABEL OPTION 2" },
//   ],
// }) {
//   const { msg } = useSelector((s) => s.language);
//   const [opt, setOpt] = useState(options);
//   const [selectedOpt, setSelectedOpt] = useState(selectedOption);
//   const [isOpenOpt, setIsOpenOpt] = useState(false);
//   const [isAddNew, setIsAddNew] = useState(false);
//   const inputAddNewRef = useRef(null);
//   const inputFilterRef = useRef(null);
//   const wrapperRef = useRef(null); // ✅ เพิ่ม ref นี้

//   // ✅ ตรวจจับคลิกนอก component (ทั้ง mouse และ touch)
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//         setIsOpenOpt(false);
//         setIsAddNew(false);
//         if (inputFilterRef.current) {
//           inputFilterRef.current.value = ""; // ✅ ล้างค่า input
//           setOpt(options); // ✅ รีเซต options กลับไปเป็นค่าเดิม (optional)
//         }
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     document.addEventListener("touchstart", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       document.removeEventListener("touchstart", handleClickOutside);
//     };
//   }, [options]);

//   const onSelect = (data) => {
//     const { value } = data;
//     const isSelected = selectedOpt.some((el) => el.value == value);
//     if (isSelected) {
//       setSelectedOpt((prev) => prev.filter((el) => el.value !== value));
//     } else {
//       setSelectedOpt((prev) => (multiple ? [...prev, data] : [data]));
//     }
//     inputFilterRef.current?.focus();
//     if (multiple === false) {
//       setIsOpenOpt(false);
//       setIsAddNew(false);
//     }
//     inputFilterRef.current.value = "";
//   };

//   const onRemove = (data) => {
//     if (disabled) return;
//     setSelectedOpt((prev) => prev.filter((el) => el.value !== data.value));
//     inputFilterRef.current.value = "";
//     if (isOpenOpt) {
//       inputFilterRef.current?.focus();
//     }
//   };

//   const onSaveAddNew = () => {
//     const newOption = inputAddNewRef.current?.value;
//     if (newOption) {
//       onSaveNewOption(newOption);
//     }
//     setIsAddNew(false);
//   };

//   const onFilter = (e) => {
//     const value = e.target.value;
//     const filtered = options.filter((el) =>
//       el.label.toLowerCase().includes(value.toLowerCase())
//     );
//     setOpt(value === "" ? options : filtered);
//   };

//   useEffect(() => {
//     onSelectOption(selectedOpt);
//   }, [selectedOpt]);

//   useEffect(() => {
//     setOpt(options);
//   }, [options]);

//   useEffect(() => {
//     if (isOpenOpt) inputFilterRef.current?.focus();
//   }, [isOpenOpt]);

//   useEffect(() => {
//     if (isAddNew) inputAddNewRef.current?.focus();
//   }, [isAddNew]);

//   return (
//     <div
//       ref={wrapperRef} // ✅ ใช้ ref กับ container หลัก
//       className={`relative rounded-md ${className}`}
//     >
//       <div
//         onClick={() => {
//           if (!disabled) {
//             inputFilterRef.current?.focus();
//             setIsOpenOpt(true);
//           }
//         }}
//         className={`border flex gap-2 min-h-[2.5rem] rounded-md items-center flex-wrap px-4 py-1 text-[0.8rem] ${
//           disabled ? "bg-[var(--soft-22)]" : ""
//         }`}
//       >
//         <input
//           type={isOpenOpt || selectedOpt.length === 0 ? "text" : "hidden"}
//           ref={inputFilterRef}
//           onChange={onFilter}
//           className="outline-none w-full bg-transparent"
//           placeholder={placeholder}
//           onFocus={() => setIsOpenOpt(true)}
//           disabled={disabled}
//         />
//         {selectedOpt.map((el, index) => (
//           <div
//             key={`selected-${el.value}-${index}`}
//             className="flex items-center gap-2 px-1 bg-[var(--soft-22)] rounded-md z-[2] text-[var(--primary)]"
//           >
//             <span className="cursor-default">{el.label}</span>
//             <span onClick={() => onRemove(el)} className="cursor-pointer">
//               <Svg iconName="close" className="size-2" />
//             </span>
//           </div>
//         ))}
//       </div>

//       {isOpenOpt && (
//         <div className="drop-shadow p-2 rounded-md flex flex-col gap-1 absolute w-full bg-[var(--bright)] z-[11]">
//           <div className="max-h-[8rem] overflow-y-auto">
//             {opt
//               .filter((el) => !selectedOpt.some((s) => s.value === el.value))
//               .map((el) => (
//                 <div
//                   key={`opt-${el.value}`}
//                   onClick={() => onSelect(el)}
//                   className="cursor-pointer text-[0.8rem] px-4 py-1 rounded-md text-[var(--primary)] hover:bg-[var(--primary)] hover:text-[var(--bright)]"
//                 >
//                   <span>{el.label}</span>
//                 </div>
//               ))}
//           </div>

//           {!disabledAddNewOption && (
//             <div className="px-2 pt-2 border-t flex items-center text-[var(--primary)] font-bold">
//               {isAddNew ? (
//                 <div className="w-full flex">
//                   <input
//                     className="font-normal border px-2 py-1 rounded-md outline-none w-full"
//                     ref={inputAddNewRef}
//                     onBlur={() => {
//                       if (!inputAddNewRef.current?.value) {
//                         setIsAddNew(false);
//                         inputFilterRef.current?.focus();
//                       }
//                     }}
//                     onChange={onFilter}
//                   />
//                   <button
//                     className="px-4 ml-2 bg-[var(--primary)] rounded-md text-[var(--bright)] text-[0.8rem]"
//                     onClick={onSaveAddNew}
//                   >
//                     {msg.save}
//                   </button>
//                 </div>
//               ) : (
//                 <div
//                   onClick={() => setIsAddNew(true)}
//                   className="cursor-pointer flex items-center gap-2 text-[0.8rem]"
//                 >
//                   <Svg iconName="add" className="size-4" />
//                   <div>{msg.add_new}</div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Svg from "./figs/Svg";
import { useSelector } from "react-redux";

const MultiSelect = forwardRef(
  (
    {
      className = "",
      placeholder = "",
      disabled = false,
      onSelectOption = () => {},
      onSaveNewOption = () => {},
      selectedOption = [],
      multiple = true,
      disabledAddNewOption = false,
      options = [
        { value: 1, label: "LABEL OPTION 1" },
        { value: 2, label: "LABEL OPTION 2" },
      ],
    },
    ref
  ) => {
    const { msg } = useSelector((s) => s.language);
    const [opt, setOpt] = useState(options);
    const [selectedOpt, setSelectedOpt] = useState(selectedOption);
    const [isOpenOpt, setIsOpenOpt] = useState(false);
    const [isAddNew, setIsAddNew] = useState(false);
    const inputAddNewRef = useRef(null);
    const inputFilterRef = useRef(null);
    const wrapperRef = useRef(null); // ✅ เพิ่ม ref นี้

    // ✅ ตรวจจับคลิกนอก component (ทั้ง mouse และ touch)
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          setIsOpenOpt(false);
          setIsAddNew(false);
          if (inputFilterRef.current) {
            inputFilterRef.current.value = ""; // ✅ ล้างค่า input
            setOpt(options); // ✅ รีเซต options กลับไปเป็นค่าเดิม (optional)
          }
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
      };
    }, [options]);

    const onSelect = (data) => {
      const { value } = data;
      const isSelected = selectedOpt.some((el) => el.value == value);
      if (isSelected) {
        setSelectedOpt((prev) => prev.filter((el) => el.value !== value));
      } else {
        setSelectedOpt((prev) => (multiple ? [...prev, data] : [data]));
      }
      inputFilterRef.current?.focus();
      if (multiple === false) {
        setIsOpenOpt(false);
        setIsAddNew(false);
      }
      inputFilterRef.current.value = "";
    };

    const onRemove = (data) => {
      if (disabled) return;
      setSelectedOpt((prev) => prev.filter((el) => el.value !== data.value));
      inputFilterRef.current.value = "";
      if (isOpenOpt) {
        inputFilterRef.current?.focus();
      }
    };

    const onSaveAddNew = () => {
      const newOption = inputAddNewRef.current?.value;
      if (newOption) {
        onSaveNewOption(newOption);
      }
      setIsAddNew(false);
    };

    const onFilter = (e) => {
      const value = e.target.value;
      const filtered = options.filter((el) =>
        el.label.toLowerCase().includes(value.toLowerCase())
      );
      setOpt(value === "" ? options : filtered);
    };

    const clearSelectedOption = () => setSelectedOpt([]);

    useImperativeHandle(ref, () => ({
      clearSelectedOption,
    }));

    useEffect(() => {
      onSelectOption(selectedOpt);
    }, [selectedOpt]);

    useEffect(() => {
      setOpt(options);
    }, [options]);

    useEffect(() => {
      if (isOpenOpt) inputFilterRef.current?.focus();
    }, [isOpenOpt]);

    useEffect(() => {
      if (isAddNew) inputAddNewRef.current?.focus();
    }, [isAddNew]);

    return (
      <div
        ref={wrapperRef} // ✅ ใช้ ref กับ container หลัก
        className={`relative rounded-md ${className}`}
      >
        <div
          onClick={() => {
            if (!disabled) {
              inputFilterRef.current?.focus();
              setIsOpenOpt(true);
            }
          }}
          className={`border flex gap-2 min-h-[2.5rem] rounded-md items-center flex-wrap px-4 py-1 text-[0.8rem] ${
            disabled ? "bg-[var(--soft-22)]" : ""
          }`}
        >
          <input
            type={isOpenOpt || selectedOpt.length === 0 ? "text" : "hidden"}
            ref={inputFilterRef}
            onChange={onFilter}
            className="outline-none w-full bg-transparent"
            placeholder={placeholder}
            onFocus={() => setIsOpenOpt(true)}
            disabled={disabled}
          />
          {selectedOpt.map((el, index) => (
            <div
              key={`selected-${el.value}-${index}`}
              className="flex items-center gap-2 px-1 bg-[var(--soft-22)] rounded-md z-[2] text-[var(--primary)]"
            >
              <span className="cursor-default">{el.label}</span>
              <span onClick={() => onRemove(el)} className="cursor-pointer">
                <Svg iconName="close" className="size-2" />
              </span>
            </div>
          ))}
        </div>

        {isOpenOpt && (
          <div className="drop-shadow p-2 rounded-md flex flex-col gap-1 absolute w-full bg-[var(--bright)] z-[11]">
            <div className="max-h-[8rem] overflow-y-auto">
              {opt
                .filter((el) => !selectedOpt.some((s) => s.value === el.value))
                .map((el) => (
                  <div
                    key={`opt-${el.value}`}
                    onClick={() => onSelect(el)}
                    className="cursor-pointer text-[0.8rem] px-4 py-1 rounded-md text-[var(--primary)] hover:bg-[var(--primary)] hover:text-[var(--bright)]"
                  >
                    <span>{el.label}</span>
                  </div>
                ))}
            </div>

            {!disabledAddNewOption && (
              <div className="px-2 pt-2 border-t flex items-center text-[var(--primary)] font-bold">
                {isAddNew ? (
                  <div className="w-full flex">
                    <input
                      className="font-normal border px-2 py-1 rounded-md outline-none w-full"
                      ref={inputAddNewRef}
                      onBlur={() => {
                        if (!inputAddNewRef.current?.value) {
                          setIsAddNew(false);
                          inputFilterRef.current?.focus();
                        }
                      }}
                      onChange={onFilter}
                    />
                    <button
                      className="px-4 ml-2 bg-[var(--primary)] rounded-md text-[var(--bright)] text-[0.8rem]"
                      onClick={onSaveAddNew}
                    >
                      {msg.save}
                    </button>
                  </div>
                ) : (
                  <div
                    onClick={() => setIsAddNew(true)}
                    className="cursor-pointer flex items-center gap-2 text-[0.8rem]"
                  >
                    <Svg iconName="add" className="size-4" />
                    <div>{msg.add_new}</div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
);

export default MultiSelect;
